import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { patchAddSubcontractor } from '../services/patchAddSubctontractor.service';
import {
  selectOrganizationBusinessIdToAdd,
  selectOrganizationBusinessNameToAdd,
} from '../selectors/organizationChart.selectors';

export const addSubcontractorNewBusiness = createAsyncThunk(
  'organizationCharts/addSubcontractorNewBusiness',
  async ({ targetOrganizationChartItemId }, { getState }) => {
    const selectedProjectId = selectSelectedProjectId(getState());

    const businessIdToAdd = selectOrganizationBusinessIdToAdd(getState());

    const businessNameToAdd = selectOrganizationBusinessNameToAdd(getState());

    const response = await patchAddSubcontractor(
      selectedProjectId,
      targetOrganizationChartItemId,
      businessIdToAdd,
      businessNameToAdd
    );

    return response;
  }
);
